import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscribeForm = () => {
  const navigate = useNavigate();

  const handleUpdatesClick = () => {
    if (typeof window !== 'undefined' && window.va) {
      window.va('event', { name: 'updates_signup_cta_click' });
    }

    navigate('/updates');
  };

  return (
    <section
      id="subscribe"
      className="bg-[#121212] text-white py-20 px-4 text-center flex flex-col items-center"
    >
      <div className="w-full max-w-3xl rounded-2xl border border-white/10 bg-[#171717] px-6 py-10 shadow-lg md:px-10 md:py-12">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
          Stay Connected
        </p>

        <h2 className="text-2xl md:text-3xl font-bold mb-4 tracking-tight">
          Sign Up for Updates and Releases
        </h2>

        <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto mb-7 leading-8">
          Get product updates, new feature releases, and launch announcements as
          FlowQuant continues to evolve.
        </p>

        <button
          type="button"
          onClick={handleUpdatesClick}
          className="inline-flex items-center justify-center rounded-lg bg-white px-6 py-2.5 text-sm md:text-base font-semibold text-black transition hover:bg-slate-200"
        >
          Join the Updates List
        </button>

        <p className="text-xs md:text-sm text-gray-500 mt-4">
          Join the FlowQuant updates list and follow new releases.
        </p>
      </div>
    </section>
  );
};

export default SubscribeForm;